module.exports = __webpack_public_path__ + "img/f6_1.c4700ff7.png";